import React, { Component } from 'react';
import ResultViePie from '../ResultViePie';
import { buildOptions, getColorScale } from './../../utils/survey';
import chroma from 'chroma-js';

const colorScale = chroma.scale(['00BFFF', '000080']).domain([0, 100]);

class ResultPlants extends Component{
	
	buildPercentOptions = (options) => {
		let percentOptions = [];
		let optionsArray = Object.entries(options);
		optionsArray.sort(function(a, b) {
			return a[1] - b[1];
		}).forEach((el) => {
			let optionAmount = Math.round(el[1] / optionsArray[optionsArray.length - 1][1] * 100);
			let optionKey = el[0];
			percentOptions.push({ x: optionKey, y: optionAmount });
		});
		return percentOptions;
	};
	
	render() {
		const { stepAnswers } = this.props;
		const answerValues = Object.values(stepAnswers);
		const options = buildOptions(answerValues);
		const colors = getColorScale(this.buildPercentOptions(options), colorScale);
		
		return <ResultViePie colors={colors} chartData={this.buildPercentOptions(options)} {...this.props}/>;
	}
}

export default ResultPlants;




// WEBPACK FOOTER //
// ./src/components/ResultPlants/ResultPlants.js